const userInitialState = {
  user: null,
  loggedInStatus: 'NOT LOGGED IN',
};

const massageListInitialState = [];

export { userInitialState, massageListInitialState };
